export const MODAL_TYPE_SEARCH_RESULTS_SORT = 'search-results-sort';
